// extracted by mini-css-extract-plugin
export default {"news_articles":"NewsArticles_news_articles__nnVAN","news_articles_container":"NewsArticles_news_articles_container__RDKML"};